<template>
<div>
  <div class="row" style="height: 60px"></div>
  <div class="row titleRow">
    <div class="col">
      <h2>{{$t('targetBodybuilding.subtitle') + $store.state.form.resultJson.userInfos.firstname + ' ' +$store.state.form.resultJson.userInfos.lastname}}</h2>
      <h1>{{$t('targetBodybuilding.title')}}</h1>
    </div>
  </div>

  <div v-for="i in Math.ceil((targetBodybuildingList.length)/nbColumn)" :key="i" class="row listOfButtons">
    <div v-for="(item, index) in targetBodybuildingList.slice((i-1)*nbColumn, (i-1)*nbColumn+nbColumn)" :key="index" :class="($isMobile() ? (i ===3) ? 'col-6' : 'col-3' : 'col')">
      <a @click="addElementToList((i-1)*nbColumn+index)"><img :src="targetBodybuildingImgList[(i-1)*nbColumn+index]" alt="ImgBodybuilding" class="imgSmall clickableItem" /><br/>
        <button :class="'btn btn-secondary targetButton ' + ((alreadyListed((i-1)*nbColumn+index) !== false) ? 'bg-color' : '')">{{item}}</button></a>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6  verticalCenter">
      <p style="display: contents;text-align: left"><em>{{$t('targetBodybuilding.selectAll')}}</em></p>
    </div>
    <div class="form-group col-md-2 verticalCenter">
      <label class="switch">
        <input v-model="selectAll" type="checkbox">
        <span class="slider round"></span>
      </label>
    </div>
  </div>
  <div class="form-row">
    <div class="form-group col-md-6  verticalCenter">
      <p style="display: contents;text-align: left"><em>{{$t('targetBodybuilding.changeInProgram')}}</em></p>
    </div>
    <div class="form-group col-md-2 verticalCenter">
      <label class="switch">
        <input v-model="sensibleChangeInProgram" type="checkbox">
        <span class="slider round"></span>
      </label>
    </div>
  </div>
  <div class="row">
    <div class="col overFooter">
      <button type="submit" :class="'btn btn-primary alignRight ' + ((returnTargetList.length > 0) ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
    </div>
  </div>
</div>
</template>

<script>
import vueSlider from 'vue-slider-component';
export default {
  name: 'target-body-building',
  components: {
    vueSlider
  },
  data () {
    return {
      nbColumn: this.$isMobile() ? 4 : 5,
      isActivated: true,
      selectAll: false,
      sensibleChangeInProgram: false,
      returnTargetList: [],
      targetBodybuildingList: [
        this.$i18n.t('targetBodybuilding.pectoral'),
        this.$i18n.t('targetBodybuilding.shoulder'),
        this.$i18n.t('targetBodybuilding.biceps'),
        this.$i18n.t('targetBodybuilding.triceps'),
        this.$i18n.t('targetBodybuilding.stomach'),
        this.$i18n.t('targetBodybuilding.legs'),
        this.$i18n.t('targetBodybuilding.backside'),
        this.$i18n.t('targetBodybuilding.back'),
        this.$i18n.t('targetBodybuilding.adductor'),
        this.$i18n.t('targetBodybuilding.abductor')],
      targetBodybuildingVarList: [
        'pectoral',
        'shoulder',
        'biceps',
        'triceps',
        'stomach',
        'legs',
        'backside',
        'back',
        'adductor',
        'abductor'],
      targetBodybuildingImgList: [
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/pectoral.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/shoulder.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/biceps.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/triceps.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/stomach.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/legs.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/backside.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/back.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/adductor.png',
        'https://sales.deciplus.pro/static/img/TargetBodybuilding/abductor.png']
    };
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'TargetBodybuilding', isAuthorized: this.returnTargetList.length !== 0, data: this.dataTosave});
  },
  deactivated: function () {
    this.isActivated = false;
  },
  activated: function () {
    this.isActivated = true;
  },
  methods: {
    saveData: function () {
      if (this.returnTargetList.length !== 0) {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.dataTosave);
      }
    },
    alreadyListed: function (index) {
      for (var i = 0; i < this.returnTargetList.length; i++) {
        if (this.targetBodybuildingVarList[index] === this.returnTargetList[i]) {
          return i;
        }
      }
      return false;
    },
    addElementToList: function (index) {
      var indexAlreadyListed = this.alreadyListed(index);
      if (indexAlreadyListed === false) {
        this.returnTargetList.push(this.targetBodybuildingVarList[index]);
      } else {
        this.returnTargetList.splice(indexAlreadyListed, 1);
      }
      this.selectAll = this.returnTargetList.length === this.targetBodybuildingVarList.length;
    },
    selectAllChanged: function (selectAll) {
      if (selectAll) {
        for (var i = 0; i < this.targetBodybuildingVarList.length; i++) {
          if (this.alreadyListed(i) === false) {
            this.addElementToList(i);
          }
        }
      } else {
        this.returnTargetList = [];
      }
    }
  },
  watch: {
    selectAll: function (val) {
      if (this.returnTargetList.length === this.targetBodybuildingVarList.length || val) {
        this.selectAllChanged(val);
      }
    }
  },
  computed: {
    dataTosave: function () {
      return {
        targetBodybuilding: {
          targetBodybuildingList: [...this.returnTargetList],
          sensibleChangeInProgram: this.sensibleChangeInProgram
        }
      };
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/layouts/TargetBodybuilding.vue